// extracted by mini-css-extract-plugin
export default {"main":"PrimaryButton_main__RG5T2","transparent":"PrimaryButton_transparent__jc2OG","icon":"PrimaryButton_icon__bQ7fC","disabled":"PrimaryButton_disabled__b5x-E"};